import { Component, OnInit } from '@angular/core';
import { creFadeInOut } from 'cre-ng';

import { User } from '@app/core/core.model';
import { FleetWeeklyDto, LeagueRankingDto } from '@app/core/driver-wig.model';
import { IDriverWigService } from '@app/core/services/interface/IDriverWigService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { AuthService } from '@app/core/auth.service';

@Component({
  animations: [creFadeInOut],
  selector: 'app-wig-fleet-banner',
  styleUrls: ['./wig-fleet-banner.component.css'],
  templateUrl: './wig-fleet-banner.component.html',
})
export class WigFleetBannerComponent implements OnInit {
  driverWigService: IDriverWigService;
  fleetWeekly: FleetWeeklyDto;
  leagueRanking: LeagueRankingDto;

  private currentUser: User;

  constructor(private authService: AuthService, private serviceFactory: ServiceFactory) {
    this.driverWigService = serviceFactory.getDriverWigService();
  }

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();

    void this.driverWigService
      .getFleetWeekly(this.currentUser.username)
      .then((data) => {
        this.fleetWeekly = data;

        if (this.fleetWeekly && this.fleetWeekly.fleet) {
          return this.driverWigService.getFleetLeagueRankings(this.fleetWeekly.fleet);
        } else {
          return Promise.resolve(null);
        }
      })
      .then((leagueRanking) => {
        this.leagueRanking = leagueRanking;
      });
  }
}
